import { render, staticRenderFns } from "./AIChatWidgetDropdown.vue?vue&type=template&id=5c8d2854&scoped=true"
import script from "./AIChatWidgetDropdown.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetDropdown.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetDropdown.vue?vue&type=style&index=0&id=5c8d2854&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d2854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8d2854')) {
      api.createRecord('5c8d2854', component.options)
    } else {
      api.reload('5c8d2854', component.options)
    }
    module.hot.accept("./AIChatWidgetDropdown.vue?vue&type=template&id=5c8d2854&scoped=true", function () {
      api.rerender('5c8d2854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetDropdown.vue"
export default component.exports